import { PropsWithChildren } from "react";
import { selectRole } from "../redux/features/user/selectors/userState.selectors";
import { useAppSelector } from "../redux/hooks/redux";
import { IRoles } from "./types/IRoles";

interface CanProps extends PropsWithChildren {
  feature?: IRoles[];
  action?: IRoles[];
  permissions?: IRoles[];
}

export function Can({ feature, action, permissions, children }: CanProps) {
  const currentRole = useAppSelector(selectRole);

  const hasRole = (allowed?: IRoles[]) => {
    if (!allowed) return true;
    if (!currentRole) return false;
    return allowed.includes(currentRole as IRoles);
  };

  if (permissions && !hasRole(permissions)) return null;
  if (feature && !hasRole(feature)) return null;
  if (action && !hasRole(action)) return null;

  return <>{children}</>;
}
